import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { RECAPTCHA_MESSAGES, RecaptchaMessages } from "../recaptcha/recaptcha.messages";

export type LoginMessages = SidebarMessages &
  RecaptchaMessages & {
    loginTitle: string;
    emailPlaceholder: string;
    loginDescription: string;
    loginStepHighlight: string;
    emailLabel: string;
    passwordPlaceholder: string;
    passwordLabel: string;
    loginAction: string;
    forgotPassword: string;
    dontHaveAnAccount: string;
    clickText: string;
    errorRequiredEmail: string;
    errorInvalidEmail: string;
    errorRequiredPassword: string;
    getUserDefaultMessage: string;
    logoAlt: string;
    rememberMe: string;
  };

export const LOGIN_MESSAGES: LoginMessages = {
  loginTitle: "Faça seu login!",
  loginDescription: "Insira seus dados para fazer o seu primeiro login e",
  loginStepHighlight: "conclua o passo a passo.",
  emailPlaceholder: "Email",
  emailLabel: "Email",
  passwordPlaceholder: "Senha",
  passwordLabel: "Senha",
  loginAction: "Fazer login",
  forgotPassword: "Esqueceu a senha?",
  dontHaveAnAccount: "Não possui uma conta?",
  clickText: "Clique aqui!",
  errorRequiredEmail: "Por favor, insira seu e-mail",
  errorInvalidEmail: "Email inválido",
  errorRequiredPassword: "Senha obrigatória",
  getUserDefaultMessage: "Erro ao buscar usuário",
  logoAlt: "Talk2Buy logo",
  rememberMe: "Me mantenha conectado",

  ...SIDEBAR_MESSAGES,
  ...RECAPTCHA_MESSAGES,
};

export default LOGIN_MESSAGES;
